import React from 'react'

export default function OnboardPPE({ className }) {
    return (
        <svg
            className={`${className} w-8 h-8`}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Hard hat */}
            <path
                d="M4 13.5A8 8 0 0 1 20 13.5V15H4v-1.5Z"
                fill="#0D9488"
            />
            <path
                d="M11.1 6V13"
                stroke="#0F766E"
                strokeWidth="1.3"
                strokeLinecap="round"
            />
            <rect x="2" y="15" width="20" height="2.4" rx="1.2" fill="#0F766E" />

            {/* "New" badge marking it apart from PPE */}
            <circle cx="18.5" cy="6" r="4.3" fill="#F59E0B" />
            <path
                d="M18.5 4v4M16.5 6h4"
                stroke="#FFFFFF"
                strokeWidth="1.4"
                strokeLinecap="round"
            />
        </svg>
    )
}
